var exports = {
  "i": "x31de4314--ed0a80--wrapper",
  "L": "x31de4314--ed0a80--overlay",
};

module.exports = exports;
